import { api } from '@/lib/api'

export const fetchOrgLijsten = (orgId: number) =>
  api.get<Record<string, string[]>>(`/api/lijsten/${orgId}`).then(r => r.data)
